import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CompanyModel } from '../models/company.model';
import { CompanyService } from '../models/company.service';
import { CompanyContactPopupComponent } from './company-contact-popup.component';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel, WeGoAuthorizedLink, Permission, PermissionType, RoleLevel } from '../../shared/config';


@Component({
  selector: 'wego-company',
  template: require('../views/company-list.component.html') + WeGoConfig.APP_VERSION,
  providers: [CompanyService],
})
export class CompanyListComponent implements OnInit {
  addCompanyLink: WeGoAuthorizedLink;
  urlCompanyAdd: string;
  urlAdminOfCompanyList: string;
  DataListModel: DataListModel;
  companyList: CompanyModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  deleteCompanyMasterHashId: string;
  removeContactPersonCompanyHashId: string;
  message: string;
  urlDefaultPage: string;
  urlCompanyUpdate: string;
  urlCompanyAdmin: string;
  urlVehicleList: string;
  urlSharedVehicleGroupList: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  roleLevel = RoleLevel;

  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;

  @ViewChild('companyContactPersonModal') public companyContactPersonModal: any;
  @ViewChild('childModal') public childModal: any;
  @ViewChild('removeContactPersonModal') public removeContactPersonModal: any;
  @ViewChild('successPopup') public successPopup: any;

  get isAnyChecked(): boolean {
    if (this.companyList) {
      let isCheck = this.companyList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.companyList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(private companyService: CompanyService
    , private authService: AuthService
    , private router: Router, private translate: TranslateService) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblCompany');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance){
      this.DataListModel.searchField = ["companyName", "contactPersonName", "instanceName"];
    }
    else{
      this.DataListModel.searchField = ["companyName", "contactPersonName"];
    }
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlCompanyAdd = this.authService.GetURL(ApplicationRouteURL.URL_COMPANY_ADD);
    this.urlCompanyUpdate = this.authService.GetURL(ApplicationRouteURL.URL_COMPANY_UPDATE);
    this.urlCompanyAdmin = this.authService.GetURL(ApplicationRouteURL.URL_COMPANYADMIN_LIST);
    this.urlVehicleList = this.authService.GetURL(ApplicationRouteURL.URL_VEHICLE_LIST);
    this.urlSharedVehicleGroupList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.urlAdminOfCompanyList= this.authService.GetURL(ApplicationRouteURL.URL_ADMIN_OF_COMPANY_LIST);
    this.GetCompanyList();
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.addCompanyLink = new WeGoAuthorizedLink(this.urlCompanyAdd, 
      Permission.PR_COMPANY_OVERVIEW, PermissionType.INSERT,'btn btn-highlight navbar-right', 'LblAddNew');
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetCompanyList();
  }

  get isDeleteAccess(): boolean {
    if (this.companyList){
      return this.companyList.some(x => x.isDeletable);
    }
    else{ return false; }
      
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetCompanyList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetCompanyList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetCompanyList();
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.companyService.ExportCompanyList(this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "Company" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetCompanyList() {
    this.isLoading = true;
    this.companyService.GetCompanyList(this.DataListModel)
      .subscribe(
      res => {
        this.companyList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowContactPersonModal(companyMasterHashId: string) {
    this.companyContactPersonModal.companyMasterHashId = companyMasterHashId;
    this.companyContactPersonModal.show();
  }

  public SuccessContactPersonModal($event: any) {
    this.GetCompanyList();
    this.popupMsg = this.translate.instant('LblContactPersonAddedSuccess');//$event.SuccessMessage;
    this.ShowSuccessPopup();
  }

  public DeleteCompany(deleteCompanyList: string[]) {
    this.isLoading = true;
    this.companyService.DeleteCompany(deleteCompanyList)
      .subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetCompanyList();
        this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public OnParentCheck(isChecked: boolean) {
    this.companyList.filter(x => x.isDeletable).forEach(x => x.isChecked = isChecked);
  }
  public ShowChildModal(companyMasterHashId?: string): void {
    this.deleteCompanyMasterHashId = companyMasterHashId;

    if (companyMasterHashId) {
      this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deleteCompanyMasterHashId = companyMasterHashId;
    }
    else {
      this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.childModal.show();
  }

  public HideChildModal(): void {
    this.deleteCompanyMasterHashId = "";
    this.childModal.hide();
  }

  public SuccessModalClick(): void {
    let deleteCompanyList: any[];
    if (this.isMultipleDelete)
      deleteCompanyList = this.companyList.filter(x => x.isChecked).map(x => x.companyMasterHashId);
    else
      deleteCompanyList.push(this.deleteCompanyMasterHashId);

    this.DeleteCompany(deleteCompanyList);
    this.childModal.hide();
  }


  public ShowRemoveContactPersonModal(companyMasterHashId?: string): void {
    this.removeContactPersonCompanyHashId = companyMasterHashId;
    this.popupMsg = this.translate.instant('LblRemoveContactPersonConfirm');
    this.removeContactPersonModal.show();
  }

  public HideRemoveContactPersonModal(): void {
    this.removeContactPersonCompanyHashId = "";
    this.removeContactPersonModal.hide();
  }

  public SuccessModalRemoveContactPersonClick(): void {
    this.RemoveCompanyContactPerson();
    console.log(this.removeContactPersonCompanyHashId);
    this.removeContactPersonModal.hide();
  }

  private RemoveCompanyContactPerson(): void {
    this.isLoading = true;
    this.companyService.RemocveCompanyContactPerson(this.removeContactPersonCompanyHashId)
      .subscribe(
      res => {
        this.popupMsg = this.translate.instant('LblContactPersonRemoveSuccess');
        this.GetCompanyList();
        this.isLoading = false;
        this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.removeContactPersonModal.hide();
        this.isLoading = false;
      });
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/company/components/company-list.component.ts